export default {"src":"/_next/static/media/logo-white.efd3a4f0.svg","height":102,"width":374,"blurWidth":0,"blurHeight":0};